import React from 'react';
import MasterUsesSelect from './MasterUsesSelect';
import MasterSourceSelect from './MasterSourceSelect';

const MasterForm = ({ masterUsesChoices, masterSourceChoices, showMaster }) => {
  return (
    <div className={`${!showMaster ? 'loading' : ''}`}>
      <h3 className='text-center mt-25 mb-25'>Master Recording Bundle</h3>
      <div className="form-group">
        <div className="row d-md-flex">
          <div className="col-md-6 pr-md-5">
            <MasterUsesSelect masterUsesChoices={masterUsesChoices} />
          </div>
          <div className="col-md-6 pl-md-5">
            <MasterSourceSelect masterSourceChoices={masterSourceChoices} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterForm;
